import { inject, Injectable, OnDestroy } from '@angular/core';
import { Prop } from '../account';
import { distinctUntilChanged, ReplaySubject, tap } from 'rxjs';
import { PropState } from './prop.state';

@Injectable({
  providedIn: 'root',
})
export class PropService implements OnDestroy {
  private state = inject(PropState)
  private propSubject = new ReplaySubject<Prop>(1)
  private _currentProp: Prop | null = null

  readonly prop$ = this.propSubject.pipe(
    tap(prop => this._currentProp = prop),
    distinctUntilChanged((a, b) => a.id === b.id)
  )

  get currentProp() {
    return this._currentProp
  }

  ngOnDestroy(): void {
    this.propSubject.complete()
  }

  setProp(prop: Prop) {
    this.propSubject.next(prop)
    this.state.handleEvent(prop.id)
  }
}
